
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`To piedāvā
                    <a href="${0}">Folksonomy Engine projekts</a>. Nevilcinieties
                    piedalīties vai sniegt atsauksmes.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Šis rīks ļauj labot sastāvdaļu sarakstu. Varat pievienot, noņemt vai rediģēt
                sastāvdaļu sarakstu.
                <br>
                Šī rakstzīme <span class="highlight">␣</span> apzīmē atstarpi.
                <br>
                Šī rakstzīme <span class="highlight">↩︎</span> apzīmē rindiņas pārtraukumu. `,
'hb28f1f2ec1744ee9': html`Šīs īpašības izveido un iesniedz lietotāji jebkāda veida lietojumam. Jūtieties
                    brīvi pievienot savas. Jūsu izveidotajām īpašībām un vērtībām
                    <strong>ir jābūt faktiskām</strong>. Jūs varat iedziļināties
                    <a href="${0}">kopienas jau izmantoto īpašību sarakstā</a>
                    vai izpētīt īpašību
                    <a href="${1}">dokumentāciju un tās meklētājprogrammu</a>.`,
's000a5b76bd3a01c2': `Notiek īpašību ielāde...`,
's000d98595e959c1e': `Iegūstiet to pakalpojumā Google Play`,
's013bdc8cf0d3583d': `Palīdziet mums ar sastāvdaļām`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Apstiprināt ražu`,
's03e9c8114521b998': `Es rediģēšu sastāvdaļas`,
's05ec315d9308091a': `Svītrkoda stūru ikona`,
's061eb5af92512c85': `Saglabāts! Vai varat palīdzēt ar vēl vienu?`,
's06847c221c4c0bc1': `Es vēlētos izveidot īpašību, lai [aprakstītu jūsu lietošanas gadījumu]...`,
's06f6c6f99db6b552': `Oriģināls`,
's081e2ad82db71e1d': `Grupētas vērtības`,
's09205907b5b56cda': `Nē`,
's0b4235aae602a950': `īpaša dokumentācija`,
's0bb2d48532acc455': `Lejupielādēt CSV failu`,
's0d5b7fee0311db68': `Īpašums`,
's0fb218abc2e157ed': `Nederīgs attēls`,
's100c4928cc74642a': `atbalstīt sabiedrības veselības pētījumu attīstību.`,
's10db5498186c083b': `Atcelt apgriešanu`,
's11a18a69b30b65ed': `Palīdziet mums labot kļūdas sastāvdaļu sarakstā`,
's1205d5f6fccf8e69': `Īpašuma vērtība`,
's15d64a0a6715285a': `Jauna atslēga`,
's166bd56d19670a72': `Tālummaiņa`,
's19059bf0c4f7c162': `Atlases apgabals`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Palīdziet mums labot informāciju par uzturvērtību`,
's1e00019dc454872d': `Lūdzu, norādiet rekvizīta nosaukumu, izmantojot atribūtu “property-name”.`,
's1e49126af0935a5b': `Produktu saraksts, kas izmanto šo īpašību`,
's21e73088de6f26f3': `Lejupielādēt lietotnē App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Dokumentējiet īpašumu`,
's300b3a6ee4e1252d': str`Slikta atbilstība ${0}%`,
's33f786bb6b4f0cf4': `Apgriešanas rezultāts`,
's33f85f24c0f5f008': `Saglabāt`,
's34be4af4e8fec4ae': `Vispirms pajautājiet kopienai`,
's36d86adc823cbfa6': `Pirms jauna īpašuma izveides apspriediet to ar kopienu:`,
's3781d25aa51a736c': `Folksonomy dzinēja dokumentācija`,
's383ae4449428b61e': `Atiestatīt apgriešanu`,
's39bcf88721a1e8ee': `Atiestatīt atlasi`,
's39e14e14300694c7': `Dokumentācija un vadlīnijas`,
's3b430cfa5c1fe7f4': str`Dokumentācija priekš ${0}`,
's3f4e4b52f230a892': `Attēlu audekls`,
's417b90913e05bc17': `Priekšskatījums`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Centrēt attēlu`,
's42dd66b2441566fd': `Centra ikona`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Pievienojiet uzturvielu`,
's453ab0dbb9b5c777': `Mainīt izmēru pa labi`,
's475b08749d0706ed': `Palīdziet mums informēt miljoniem patērētāju visā pasaulē par to, ko viņi ēd`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Produktu skaits`,
's4df2f533c0c1e7d0': `Attēlu vadīklas`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Pārvietot atlasi`,
's4f751fb9b3ed766c': `Jauna īpašuma izveide`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Ievadiet īpašuma nosaukumu...`,
's55d7249883a98ca1': `par šo īpašumu vietnē Open Food Facts wiki`,
's565867d84c04aea2': `Filtra īpašības...`,
's5666afe5cd0166de': `Lūdzu, pirms apstiprināšanas izlabojiet kļūdas vai rediģējiet tekstu.`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Notiek produktu ielāde...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Palīdziet mums labot informāciju par uzturvērtību.`,
's5dd6f12783fca34f': `Rediģēt sastāvdaļu sarakstu`,
's5e8250fb85d64c23': `Aizvērt`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `ES ATBALSTU`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Rediģēt`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Paldies par jūsu ieguldījumu!`,
's6cee7cad81dfedd1': `Apgriezts attēls`,
's6d7b6cdedaadfb6e': `Katrs ziedojums ir svarīgs! Mēs novērtējam jūsu atbalstu pārtikas pārredzamības veicināšanā pasaulē.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Laba atbilstība ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentācija`,
's787dd11bed0dc88a': `Mainīt izmēru pa kreisi`,
's7ce4fd9430e80cea': `vērtība`,
's801a05fa8e881f37': `Uzziniet vairāk par īpašumu izveidi un vadlīnijām:`,
's8038273de2cf8b73': `Lūdzu, atlasiet apgriežamo reģionu.`,
's839cc2908a5387f2': `Filtrēt svītrkodus...`,
's86197dcf3e96af64': `Pārlūkot un meklēt esošos īpašumus`,
's8a63be30a129a59c': `Mainīt apakšas izmēru`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Mainīt izmēru augšējā labajā stūrī`,
's8db84aa4bc949af2': `Dokumentējiet jauno īpašumu`,
's8f839a03997a16d7': `Skatīt produktu`,
's901ae1e236ac45d3': `Atcelt dzēšanu`,
's907f7a97c6b29425': `Ņemiet vērā, ka datu modelis var tikt mainīts. Izmantojiet to uz savu atbildību.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Sastāvdaļas:`,
's9a7f60fce090ecaf': `Neizdevās ielādēt rekvizītus. Lūdzu, mēģiniet vēlreiz vēlāk.`,
's9b87abd68fb9df45': `Neatradāt? Izveidojiet jaunu atslēgu {value}`,
's9c0f52425fd2f07e': `Var neatbilst`,
's9fc41f789c63b40d': `Produkti`,
'sa1fa766e0d5634d7': `Nav pieejams rezultāts`,
'sa548778b24054030': `Izpētiet visus Folksonomy Engine projekta pievienotos rekvizītus. Šie rekvizīti sniedz papildu metadatus un ieskatu par produktiem Open Food Facts datubāzē.`,
'sa63907958bd0ec4b': `Mainīt izmēru augšējā kreisajā stūrī`,
'sa95b4224f685a36a': `Aizvērt modālo logu`,
'sab56a1d439576fd6': `Ieteikuma ikona`,
'sac47ea2901d04c15': `Mainīt izmēru apakšējā kreisajā stūrī`,
'sb125227d436c2925': `Meklējiet savu īpašuma koncepciju esošajā īpašumu datubāzē:`,
'sb125568d43642e6f': `Atbildiet uz jautājumiem par produktu.`,
'sb1c538e038f9b214': str`Ļoti laba atbilstība ${0}%`,
'sb28639570ff3b852': `visu īpašumu saraksts`,
'sb3bdd638a58d30f4': `iesaistīt apņēmīgu pilsoņu kopienu,`,
'sb3cbcc1bd0fff140': `Kad esat pārliecinājies, ka jūsu īpašums neeksistē un kopiena piekrīt, ka tas ir noderīgs, vispirms tas ir jādokumentē wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Šim īpašumam nav atrasts neviens produkts.`,
'sb7f72e4c8a2d3357': `Filtrēt vērtības...`,
'sb8178320160f84ea': `Rādīt apgriešanu`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Uz visiem jautājumiem ir atbildēts! Paldies par jūsu palīdzību!`,
'sbd9a0b2293b3cd3c': `Porcijas lielums`,
'sbe472dc3c2685985': `Atbilstošā vērtība`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Mainīt augšdaļas izmēru`,
'sc1c08d0cbcc3bd24': `Neatbilst`,
'sc52696641af72b53': `Instalējiet lietotni!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Ieteiktais labojums`,
'sc681b137e8f604f7': `Apstiprināt dzēšanu`,
'sc6daf8a31883f8b9': `Pārvietot attēlu`,
'sc895972c88d38ca5': `Folksonomijas īpašums`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Rindas`,
'scb3b0671d7b7f640': `Jauna vērtība`,
'scb489a1a173ac3f0': `Jā`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Pievienojieties Slack diskusijai`,
'scdb6cad0b92721bf': `Nav atrasts neviens īpašums.`,
'scf23a05631f93732': `Apstiprināt dzēšanu`,
'scfed2f270ef6a3aa': `Izvēlieties apgabalu`,
'sd1022bc1ef9204f7': `Pietuvināma attēla`,
'sd1077c055cf9ba6b': `Palīdziet mums validēt produkta sastāvdaļu sarakstu.`,
'sd698d21ddecba56b': `Sveiki! Jūs varat palīdzēt mums uzlabot informāciju par produktu, atbildot uz tālāk norādītajiem jautājumiem.`,
'sd82bc2decefa621b': `saglabāt neatkarību no pārtikas rūpniecības,`,
'sdb97e5976482606e': `Pārbaudiet, vai īpašums jau pastāv`,
'sdbf806fefc584115': `Jums vajadzētu atrast`,
'sdc673e73b5c13aea': `Dzēst`,
'sdc792b75f1edcaba': `Palīdziet mums izlabot sastāvdaļu pareizrakstību.`,
'sdca5deead576ceee': `Mainīt izmēru apakšējā labajā stūrī`,
'sdcc2555c5dde524f': `Vai tiešām vēlaties dzēst šo vienumu? Šo darbību nevar atsaukt.`,
'se206feec7ec57b28': `uz 100 g`,
'se419a9ab36987490': `Atzīt par nederīgu`,
'se5127cf0f92e7e48': `Padoms: varat atrast arī`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Es piedāvāšu labāku ražu`,
'seea3800e27baa686': `Atsevišķi produkti`,
'sefaba4adc4ec9219': `Folksonomijas īpašības`,
'seffa8ca49175b5f0': `Personalizētas īpašības`,
'sf44a6b3b232c28ea': str`Aizstāt pašreizējo vērtību ar ${0}`,
'sf4cd86a2f5ef2588': `Produkta svītrkods`,
'sf57a61152168cc81': `Palīdziet mums labot sastāvdaļu noteikšanu`,
'sf88b90b8ba23871c': `Nezināma atbilstība`,
'sf9aee319a006c9b4': `Pievienot`,
'sfacbbe968fa7d773': `Īpašuma nosaukums:`,
'sfc40ea3d5d5aa6f8': `Jūsu ziedojumi finansē mūsu bezpeļņas asociācijas ikdienas darbību:`,
'sfe87465d50530725': `Atbilstošā vērtība`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  